import $ from 'jquery'
import {
  prepareChessboard,
  showMagnus,
  loadNextConfiguration,
  validateMove,
  restrictMove,
  showCapturedPieces,
  hideCapturedPieces
} from '../../utils';
import ChessBoard from '../../components/chessBoard';
import User from '../../classes/user';
import {
  WHITE_INITIAL_MOVE,
  BLACK_PIECE_SEARCH_KEY,
} from '../../utils/constants'

var moveCount;

/**
* @name lesson5Assignment1
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson5Assignment1(config) {
  let initialBoardPosition = config.position,
    next = config.next;

  let afterLoad = function () {
    prepareChessboard(config);
    moveCount = 0;
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, BLACK_PIECE_SEARCH_KEY)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateMove(source, target, piece, true);
  }

  var onSnapEnd = function () {
    let boardFen = ChessBoard.board.fen();

    moveCount++;

    if (moveCount === 2) {
      if (boardFen === config.resultFen) {
        showMagnus({
          data: `Nice job ${User.user.name}!`,
          position: 'left',
          styleClass: 'xs'
        })
        loadNextConfiguration(2000, next, true)
      } else {
        showMagnus({
          data: `Oops...! Try again.`,
          position: 'left',
          styleClass: 'xs'
        })
        // ChessBoard.game = new window.Chess(config.positionFen);
        setTimeout(function () {
          showMagnus({
            data: `You have only 2 moves.`,
            position: 'left',
            styleClass: 'sm'
          })
          moveCount = 0;
          ChessBoard.board.position(initialBoardPosition);
          ChessBoard.game = new window.Chess(initialBoardPosition + WHITE_INITIAL_MOVE);
          return 'snapback';
        }, 3000)
      }
    } else {
      ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE);
    }
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson5Assignment2
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson5Assignment2(config) {
  let next = config.next,
    initialBoardPosition = config.position,
    tryCount = 0,
    timeDelay = 2000;
    
  let afterLoad = function () {
    prepareChessboard(config);
    tryCount = 0
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, BLACK_PIECE_SEARCH_KEY)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target
    });

    if (move === null) {
      return 'snapback'
    } else {
      if (!move.captured) {
        ChessBoard.game = new window.Chess(ChessBoard.board.fen() + WHITE_INITIAL_MOVE);
        return 'snapback'
      } else {
        showCapturedPieces(piece, move)
      }
    }
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();

    if (boardFen === config.resultFen) {
      loadNextConfiguration(2000, next, true)
    }

    if (
      (boardFen === '8/1p3p2/p5p1/8/4p3/8/8/3B4') ||
      (boardFen === '8/8/B7/8/8/8/8/3n4') ||
      (boardFen === '8/8/B7/8/8/1p6/8/3n4') ||
      (boardFen === '8/1p6/p5p1/8/4p3/8/8/3B4')
    ) {
      
      

      $('.square-55d63').addClass('no-action');

      let magnusMsg = "";
      tryCount = tryCount + 1;
      if (tryCount <= 1) {
        showMagnus({
          data: 'Oops...!!!<br/> Try again',
          position: 'left',
          styleClass: 'xs'
        })
        timeDelay = 4000
      } else {
        timeDelay = 1000
      }

      if (tryCount > 1) {
        magnusMsg = "Follow this path…<br/> c4-a6-b7-e4-g6-f7-b3-d1.";
      } else {
        magnusMsg = "Capture the Knight last!"
      }

      setTimeout(function () {
        
        showMagnus({
          data: magnusMsg,
          position: 'left',
          styleClass: 'lg'
        });
        
        $('.square-55d63').removeClass('no-action');
        hideCapturedPieces()
        ChessBoard.board.position(initialBoardPosition);
        ChessBoard.game = new window.Chess(initialBoardPosition + WHITE_INITIAL_MOVE);
        return 'snapback';
      }, timeDelay)
    }

    ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE);
  };


  const chessConfig = {
    config: {
      position: initialBoardPosition,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_5/assignments.js